import React from "react";
import "./QualitySelector.css";

const QualitySelector = ({
  qualities,
  selectedQuality,
  onSelectQuality,
  connectionSpeed
}) => {
  return (
    <div className="quality-selector">
      <div className="quality-dropdown">
        <select
          value={selectedQuality}
          onChange={e => onSelectQuality(e.target.value)}
        >
          <option value="auto">Auto</option>
          {qualities.map(quality => (
            <option key={quality} value={quality}>
              {quality.toUpperCase()}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default QualitySelector;
